export default "<div class=\"as-list\">\r\n\r\n    <ng-content></ng-content>\r\n</div>\r\n  <br><br>\r\n"